import "./index.css";
import { useTranslation } from "react-i18next";
import { Avatar, Column, Row, Skeleton, Typography } from "@/ui-kit";
import { AddressUtils } from "@/utils/address";
import { NotProvided } from "@/components/NotProvided";
import type { ICompanyChangeRequest } from "@/types/company-change-request";
import type { ILender } from "@/types/companies-lenders";
import type { IContractingCompany } from "@/types/companies-contractors";

type IProps = {
  request: ICompanyChangeRequest;
  currentCompany: ILender | IContractingCompany;
  newCompany: ILender | IContractingCompany | undefined;
  newCompanyLoading: boolean;
};

export const ChangeCompanyDetails = ({
  request,
  currentCompany,
  newCompany,
  newCompanyLoading,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Column gap={16} fullWidth>
      <Column gap={8} fullWidth>
        <Typography
          color="text-secondary"
          text={t("label.changeCompany.currentCompany")}
        />
        <Row gap={12}>
          <Avatar size="lg" src={currentCompany.companyLogo} />
          <Column fullWidth>
            <Typography
              variant="headline"
              weight="bold"
              color="text-primary"
              text={currentCompany.name}
            />
            <Typography
              variant="body"
              color="text-secondary"
              text={AddressUtils.format(currentCompany.address)}
            />
          </Column>
        </Row>
      </Column>

      <Column gap={8} fullWidth>
        <Typography
          color="text-secondary"
          text={t("label.changeCompany.requestedCompany")}
        />
        <Row gap={12}>
          {newCompanyLoading ? (
            <Skeleton width="100%" height="2.625rem" />
          ) : (
            <>
              <Avatar
                size="lg"
                src={newCompany ? newCompany.companyLogo : undefined}
                text={newCompany ? newCompany.name : request.newCompanyName}
                showDetails={false}
                loading={newCompanyLoading}
              />
              <Column fullWidth>
                <Typography
                  variant="headline"
                  weight="bold"
                  color="text-primary"
                  text={newCompany ? newCompany.name : request.newCompanyName}
                  loading={newCompanyLoading}
                />
                {newCompany && (
                  <Typography
                    variant="body"
                    color="text-secondary"
                    text={AddressUtils.format(newCompany?.address)}
                  />
                )}
              </Column>
            </>
          )}
        </Row>
      </Column>

      <Column gap={8} fullWidth>
        <Typography color="text-secondary" text={t("label.comment")} />
        <Typography
          color="text-primary"
          text={request?.comment || <NotProvided />}
        />
      </Column>
    </Column>
  );
};
